import { render, staticRenderFns } from "./BranchLabReport.vue?vue&type=template&id=52705632"
import script from "./BranchLabReport.vue?vue&type=script&lang=js"
export * from "./BranchLabReport.vue?vue&type=script&lang=js"
import style0 from "./BranchLabReport.vue?vue&type=style&index=0&id=52705632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports